export function MinuteNetWorkMessage(showInfo) {
  let baseMinimaError = showInfo.audience != null && showInfo.audience.length > 0 && showInfo.audience.some(audienceItem => audienceItem[2] === "");
  const showDiv = showInfo.info || baseMinimaError ? "0px" : "-100px";
  return (
    <div
      className="alertMessage"
      style={{
        position: "fixed",
        width: "270px",
        left: "50%",
        marginLeft: "-130px",
        bottom: showDiv,
        backgroundColor: "#001e78",
        borderRadius: "10px 10px 0px 0px",
        boxShadow: "rgba(0, 0, 0, 0.3) 3px 4px 20px 0px",
        padding: "15px",
        color: "#fff",
        fontSize: "12px",
        lineHeight: "25px",
        transition: "bottom 1s ease 0s",
        zIndex: "3",
      }}
    >
      <div
        style={{
          border: "1px solid #fff",
          width: "27px",
          height: "27px",
          borderRadius: "25px",
          fontSize: "16px",
          float: "left",
          marginRight: "10px",
          textAlign: "center",
          color: "#fff"
        }}
      >
        i
      </div>
      <span>{showInfo.infoText}</span>
    </div>
  );
}